/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_EMP_FORMPOST, GET_EMP_DETAILDATA } from "../../actions";

import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  showContaimerLoader,
  hasPermission,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
var module = "employee/staffcategory";
var modulePath = "/hrms/staffcategory";
var moduleName = "Staff Category";
const moduleID = 40;
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = this.props.match.params?.editID ?? '';
    this.state = {
      editID:editID,
      postdata: {
        staffcategoryName: "",
        staffcategoryStatus: "",
      },
      detaildata: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      var params = {
        params:'',
        url: `${module}/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].success === true) {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      this.state.editID !== ""
    ) {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].success === true) {
          var result = nextProps.detaildata[0].result;

          var staffcategoryStatus = result.staffcategoryStatus === "A" ? "Active" : "In Active";
          var status =
            result.staffcategoryStatus !== "" && result.staffcategoryStatus !== null
              ? {
                  label: staffcategoryStatus,
                  value: result.staffcategoryStatus,
                }
              : "";
          var clientupdatedata = {
            staffcategoryName: result.staffcategoryName,
            staffcategoryStatus: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push("/" + module);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      staffcategoryName: postData.staffcategoryName,
      staffcategoryStatus: postData.staffcategoryStatus?.value ?? 'I',
    };

    var post_url = `${module}/create`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="staffcategory" {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid mx-3">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop:
                                        $(document)
                                          .find("#modulefrm .error:first")
                                          .offset().top - 100,
                                    },
                                    500
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.empformpost,
    detaildata: state.empdetaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_EMP_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_EMP_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { staffcategoryName, staffcategoryStatus } = props.fields;

  return {
    fields: [ "staffcategoryName", "staffcategoryStatus"],
    validations: {
      staffcategoryName: [[isEmpty, staffcategoryName]],
      staffcategoryStatus: [[isSingleSelect, staffcategoryStatus]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
  }

  goBack() {
    this.props.history.push(modulePath);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgstaffcategoryName,
      errMsgStatus = "";
    if ($validation.staffcategoryName.error.reason !== undefined) {
      errMsgstaffcategoryName = $validation.staffcategoryName.show && (
        <span className="error">{$validation.staffcategoryName.error.reason}</span>
      );
    }
    if ($validation.staffcategoryStatus.error.reason !== undefined) {
      errMsgStatus = $validation.staffcategoryStatus.show && (
        <span className="error">{$validation.staffcategoryStatus.error.reason}</span>
      );
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-5">
              <label className="form-label">
                Staff Category Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Staff Category Name"
                name="staffcategoryName"
                value={fields.staffcategoryName}
                {...$field("staffcategoryName", (e) =>
                  onChange("staffcategoryName", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgstaffcategoryName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.staffcategoryStatus}
                onChange={this.handleSelectChange.bind(this, "staffcategoryStatus")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: 'A', label: "Active" },
                  { value: 'I', label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div
              className="btn-group me-2 sw-btn-group-extra submit_frm"
              role="group"
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Submit
              </button>

              <button
                className="btn btn-secondary"
                onClick={this.goBack.bind(this)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
